import { Component, FC, ReactNode } from 'react';

import type { SellerReviewsModalProps } from './SellerReviewsModal';
type SellerReviewsModalAsyncState = {
    SellerReviewsModal?: FC<SellerReviewsModalProps>;
};

export class SellerReviewsModalAsync extends Component<
    SellerReviewsModalProps,
    SellerReviewsModalAsyncState
> {
    constructor(props: SellerReviewsModalProps) {
        super(props);
        this.state = { SellerReviewsModal: undefined };
        this.loadComponent = this.loadComponent.bind(this);
    }

    componentDidMount(): void {
        if (this.props.isOpen) {
            this.loadComponent();
        }
    }

    componentDidUpdate(): void {
        if (this.props.isOpen && !this.state.SellerReviewsModal) {
            this.loadComponent();
        }
    }

    loadComponent(): void {
        import(/* webpackChunkName: "SellerReviewsModal" */ './SellerReviewsModal').then(mod => {
            this.setState(() => ({ SellerReviewsModal: mod.SellerReviewsModal }));
        });
    }

    render(): ReactNode {
        const { SellerReviewsModal } = this.state;
        if (!SellerReviewsModal) {
            return null;
        }
        return <SellerReviewsModal {...this.props} />;
    }
}
